import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

let accessToken = null;
export const setAccessToken = (t) => { accessToken = t; };
export const getAccessToken = () => accessToken;

export const api = axios.create({ baseURL: BACKEND_URL, withCredentials: true });

api.interceptors.request.use((config) => {
  if (accessToken) config.headers.Authorization = `Bearer ${accessToken}`;
  return config;
});

let refreshing = null;
async function doRefresh() {
  const { data } = await axios.post(`${API}/auth/refresh`, {}, { withCredentials: true });
  setAccessToken(data.access_token);
  return data;
}

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url = original.url || "";
    const skip = url.includes("/auth/refresh") || url.includes("/auth/login") || url.includes("/auth/register");
    if (error.response?.status === 401 && !original._retry && !skip) {
      original._retry = true;
      try {
        if (!refreshing) refreshing = doRefresh().finally(() => { refreshing = null; });
        await refreshing;
        original.headers = original.headers || {};
        original.headers.Authorization = `Bearer ${getAccessToken()}`;
        return api(original);
      } catch (e) {
        setAccessToken(null);
        throw error;
      }
    }
    throw error;
  }
);

export function apiError(e, fallback = "Something went wrong. Please try again.") {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || fallback;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((x) => (x && typeof x.msg === "string" ? x.msg : JSON.stringify(x))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return fallback;
}

export { doRefresh };
